<template>
  <div>
    <CarouselComponent/>
    <HomeDividerText/>
    <HomeCards/>
    <Footer/>

    <transition name="fade">
      <div v-if="showPopup" class="new-product-popup" @click.self="closePopup">
        <div class="popup-content">
          <button class="close-btn" @click="closePopup">×</button>
          <router-link :to="`/shop/item/${newestProduct.id}`">
            <img :src="newestProduct.imageUrl" alt="Novi proizvod" class="promo-image">
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CarouselComponent from "@/component/user/home/carousel/CarouselComponent";
import HomeDividerText from "@/component/user/home/HomeDividerText";
import HomeCards from "@/component/user/home/HomeCards";
import Footer from "@/component/user/Footer.vue";

export default {
  name: 'Home',
  components: { Footer, CarouselComponent, HomeDividerText, HomeCards },
  data() {
    return {
      showPopup: false,
      newestProduct: {
        id: 42,
        imageUrl: 'https://i.ibb.co/DfDdgk6q/sni-enje-3.jpg' // your marketing image
      }
    }
  },
  mounted() {
    // Only show popup if not shown before
    if (!localStorage.getItem('popupShown')) {
      setTimeout(() => { this.showPopup = true }, 1000);
    }
  },
  methods: {
    closePopup() {
      this.showPopup = false;
      localStorage.setItem('popupShown', 'true');
    }
  }
}
</script>

<style scoped>
/* Fade animation */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.6s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* Popup overlay */
.new-product-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* Popup container */
.popup-content {
  position: relative;
  background: transparent;
  border-radius: 12px;
  max-width: 500px;
  overflow: hidden;
  animation: scaleIn 0.4s ease;
}

@keyframes scaleIn {
  0% { transform: scale(0.9); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

/* Marketing image */
.promo-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 12px;
  cursor: pointer;
}

/* Close button (inside popup) */
.close-btn {
  position: absolute;
  top: 8px;
  right: 10px;
  border: none;
  background: rgba(255,255,255,0.8);
  font-size: 20px;
  font-weight: bold;
  color: #333;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  line-height: 26px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: rgba(255,255,255,1);
}
</style>
